import React, { Fragment, Component } from 'react';
import Title from './Title';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getAllCharity } from '../../Graphs/Charity/listCharity';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Spin, notification, Button } from 'antd';
import { addCharity } from '../../Graphs/Charity/addCharity';
import { AddCharity } from './AddCharity';
import CharityRecordsTable from './CharityRecordsTable';

class Charity extends Component {
	constructor(props) {
		super(props);
		this.state = {
			charityList: [],
			charityTotal: 0,
			isLoading: false,
			primaryColor: '#4466f2',
			envData: null,
		};
		this.resetTablePagination = null;
	}

	async componentDidMount() {
		try {
			const { setRouteName, setSearchText } = this.props;
			let editPrimaryColor = await localStorage.getItem('primary_color');

			await setRouteName('CHARITY');
			await setSearchText('');

			this.setState({
				isLoading: true,
				primaryColor: editPrimaryColor,
			});

			await this.listCharityData();
		} catch (e) {
			notification['error']({
				message: 'Charity',
				description: typeof e === 'string' ? e : 'Something went wrong',
			});
		} finally {
			this.setState({
				isLoading: false,
			});
		}
	}

	listCharityData = async () => {
		const {
			authToken,
			history,
			setLoginFlag,
			setUserData,
			setUserToken,
			setListCharityData,
			setListCharityDataTotal,
		} = this.props;
		try {
			this.setState({
				isLoading: true,
			});
			let charityData = await getAllCharity(authToken, 0, 10);

			if (charityData.status === 200) {
				//set category data
				await setListCharityData(charityData.data);
				await setListCharityDataTotal(charityData.total);

				this.setState({
					charityList: charityData.data,
					charityTotal: charityData.total,
				});
			} else if (charityData.status === 401) {
				await setLoginFlag(false);
				await setUserData(null);
				await setUserToken(null);
				history.push(`${process.env.PUBLIC_URL}/login`);
			}
		} catch (e) {
			throw e;
		} finally {
			this.setState({
				isLoading: false,
			});
		}
	};

	addSubmit = async (values) => {
		try {
			const { authToken } = this.props;
			this.setState({
				isLoading: true,
			});
			let addCategoryData = await addCharity(authToken, values);
			await this.listCharityData();
			if (this.resetTablePagination) {
				this.resetTablePagination();
			}
		} catch (e) {
			notification['error']({
				message: 'Edit Charity',
				description: typeof e === 'string' ? e : 'Something went wrong',
			});
		} finally {
			this.setState({
				isLoading: false,
			});
		}
	};

	render() {
		const { primaryColor, charityList, isLoading, charityTotal } = this.state;

		return (
			<Fragment>
				<Title parent="Organizations" title="Organizations" />

				<div
					style={{
						marginTop: '20px',
						display: 'inline-block',
						width: '100%',
						marginBottom: '20px',
						paddingLeft: '14px',
						paddingRight: '55px',
					}}
				>
					<div style={{ float: 'left', cursor: 'pointer' }}>
						<AddCharity
							primaryColor={primaryColor}
							onSubmit={this.addSubmit}
							authToken={this.props.authToken}
						/>
					</div>
				</div>

				<div className="container-fluid">
					{isLoading ? (
						<div style={{ marginLeft: '20px' }}>
							<Spin size="large" style={{ marginLeft: '480px', marginTop: '130px' }} />
						</div>
					) : (
						<div>
							<CharityRecordsTable
								registerResetPagination={(fn) => {
									this.resetTablePagination = fn;
								}}
								data={charityList}
								primaryColor={primaryColor}
								charityTotal={charityTotal}
							/>
						</div>
					)}
				</div>
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	authToken: state.auth.authToken,
});

const mapDispatchToProps = (dispatch) => {
	return {
		setLoginFlag: (flag) => {
			dispatch({
				type: 'SET_LOGIN_FLAG',
				flag: flag,
			});
		},
		setUserData: (userData) => {
			dispatch({
				type: 'SET_USER_DATA',
				userData: userData,
			});
		},
		setUserToken: (authToken) => {
			dispatch({
				type: 'SET_USER_AUTHTOKEN',
				authToken: authToken,
			});
		},
		setListCharityData: (listCharityData) => {
			dispatch({
				type: 'SET_LIST_CHARITY_DATA',
				listCharityData: listCharityData,
			});
		},
		setListCharityDataTotal: (listCharityDataTotal) => {
			dispatch({
				type: 'SET_LIST_CHARITY_DATA_TOTAL',
				listCharityDataTotal: listCharityDataTotal,
			});
		},
		setRouteName: (routeName) => {
			dispatch({
				type: 'SET_ROUTE_NAME',
				routeName: routeName,
			});
		},
		setSearchText: (searchText) => {
			dispatch({
				type: 'SET_SEARCH_TEXT',
				searchText: searchText,
			});
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Charity));
